export default __webpack_public_path__ + "static/media/bankid.79d156aa.svg";